(() => {
  const initializePhotoViewer = (section) => {
    const dialog = section.querySelector('[data-google-review-photo-dialog]');
    const dialogImage = dialog?.querySelector('[data-google-review-photo-image]');
    const closeButton = dialog?.querySelector('[data-google-review-photo-close]');
    const openButtons = Array.from(section.querySelectorAll('[data-google-review-photo-open]'));

    if (!dialog || !dialogImage || !closeButton || openButtons.length === 0) return;

    let opener;

    const cleanup = () => {
      document.documentElement.classList.remove('google-reviews-photo-modal-open');
      dialogImage.removeAttribute('src');
      dialogImage.alt = '';
      opener?.focus();
      opener = undefined;
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        cleanup();
      }
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        opener = button;
        dialogImage.src = button.dataset.googleReviewPhotoSrc;
        dialogImage.alt = button.dataset.googleReviewPhotoAlt || '';
        document.documentElement.classList.add('google-reviews-photo-modal-open');

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }

        closeButton.focus();
      });
    });

    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', cleanup);
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        event.preventDefault();
        closeButton.focus();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
      }
    });
  };

  const initializeCarousel = (section) => {
    if (section.dataset.googleReviewsReady === 'true') return;

    section.dataset.googleReviewsReady = 'true';
    initializePhotoViewer(section);

    const track = section.querySelector('[data-google-reviews-track]');
    const pagination = section.querySelector('[data-google-reviews-pagination]');
    const cards = Array.from(section.querySelectorAll('[data-google-review-card]'));
    const previous = section.querySelector('[data-google-reviews-prev]');
    const next = section.querySelector('[data-google-reviews-next]');
    const counter = section.querySelector('[data-google-reviews-counter]');
    if (!track || !pagination || !cards.length || !previous || !next || !counter) return;
    let frame;
    let active = 0;
    const update = () => {
      frame = undefined;
      const left = track.getBoundingClientRect().left;
      const max = track.scrollWidth - track.clientWidth;
      active = cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? index : best, 0);
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const visible = desktop ? cards.filter(card => {
        const rect = card.getBoundingClientRect();
        return rect.left < left + track.clientWidth - 2 && rect.right > left + 2;
      }) : [cards[active]];
      track.style.height = `${Math.ceil(Math.max(...visible.map(card => card.getBoundingClientRect().height)))}px`;
      if (track.scrollTop !== 0) track.scrollTop = 0;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      const last = desktop ? cards.indexOf(visible[visible.length - 1]) + 1 : active + 1;
      counter.textContent = desktop ? `${active + 1}–${last} / ${cards.length}` : `${active + 1} / ${cards.length}`;
      pagination.hidden = max <= 2;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const go = (index) => {
      const card = cards[Math.max(0, Math.min(cards.length - 1, index))];
      track.scrollTo({left: card.offsetLeft, top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => go(active - 1));
    next.addEventListener('click', () => go(active + 1));
    track.addEventListener('scroll', schedule, {passive: true});
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      const target = {ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: cards.length - 1}[event.key];
      if (target !== undefined) { event.preventDefault(); go(target); }
    });
    const observer = new ResizeObserver(schedule);
    cards.forEach(card => observer.observe(card));
    window.addEventListener('resize', schedule);
    update();
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-google-reviews]')) initializeCarousel(scope);
    scope.querySelectorAll('[data-google-reviews]').forEach(initializeCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
